<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-snackbar
        v-model="snackbar"
        :color="snackColor"
        :right="true"
        :bottom="true"
        :timeout="4000"
      >
        {{ snackText }}
        <template #action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>

      <v-card elevation="0">
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="font-weight: 500">
            Dashboard Becas Externas
          </v-toolbar-title>

          <div class="mt-6 ml-3" style="width: 180px">
            <v-autocomplete
              v-model="selectCiclo"
              :items="cmbCiclos"
              color="primary"
              item-text="nombre"
              item-value="nombre"
              label="Ciclo"
              no-data-text="Sin resultados"
              placeholder="Seleccionar..."
              dense
            />
          </div>
          <div class="mt-6 ml-3" style="width: 320px">
  <v-autocomplete
    v-model="selectInstitucion"
    :items="cmbInstituciones"
    color="primary"
    item-text="nombre"
    item-value="institucionPatrocinadoraId"
    label="Institución"
    no-data-text="Sin resultados"
    placeholder="Todas"
    clearable
    dense
  />
</div>


          <v-spacer />

<!-- BOTON REFRESCAR -->
<v-tooltip bottom color="primary">
  <template #activator="{ on, attrs }">
    <v-btn
      icon
      v-bind="attrs"
      v-on="on"
      :loading="loading"
      :disabled="!selectCiclo || loading"
      @click="refrescarDashboard"
    >
      <v-icon>fa-sync-alt</v-icon>
    </v-btn>
  </template>
  <span>Refrescar dashboard</span>
</v-tooltip>

          <v-tooltip bottom color="primary">
            <template #activator="{ on, attrs }">
          <ReportesSolicitudesDialog
  :ciclo="selectCiclo"
  :carreras="carrerasDisponibles"
  :instituciones="cmbInstituciones"
  :loading="generandoReporte"
  @reporte-completo="onReporteCompleto"
/>

            </template>
            <span>Descarga un reporte con los datos del ciclo seleccionado</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <!-- KPIs -->
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Total becarios</div>
                <div class="text-h4 font-weight-bold">{{ kpi.total }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Instituciones</div>
                <div class="text-h4 font-weight-bold">{{ kpi.instituciones }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Carreras</div>
                <div class="text-h4 font-weight-bold">{{ kpi.carreras }}</div>
              </v-card>
            </v-col>

        
          </v-row>

          <!-- Gráficas (placeholder simple con tablas + barras visuales) -->
          <v-row>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Instituciones ({{ selectCiclo || '—' }})
                </div>

                <v-skeleton-loader v-if="loading" type="list-item@5" />

                <div v-else>
                  <div v-if="chartInstituciones.length === 0" class="text-body-2">
                    No hay datos para graficar.
                  </div>

                  <div v-for="row in chartInstituciones" :key="row.label" class="mb-2">
                    <div class="d-flex justify-space-between">
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                    <v-progress-linear
                      :value="row.pct"
                      height="10"
                      rounded
                    />
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Carreras ({{ selectCiclo || '—' }})
                </div>

                <v-skeleton-loader v-if="loading" type="list-item@5" />

                <div v-else>
                  <div v-if="chartCarreras.length === 0" class="text-body-2">
                    No hay datos para graficar.
                  </div>

                  <div v-for="row in chartCarreras" :key="row.label" class="mb-2">
                    <div class="d-flex justify-space-between">
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                    <v-progress-linear
                      :value="row.pct"
                      height="10"
                      rounded
                    />
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Detalle / Listado -->
          <v-row>
            <v-col cols="12">
              <v-card outlined class="pa-2">
              

                <!-- Aquí se incrusta tu componente actual -->
                <BecariosExternos />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../../helpers'
import BecariosExternos from '../BecariosExternos.vue'
import ReportesSolicitudesDialog from './ReportesSolicitudesDialog.vue'
import XLSX from 'xlsx'


export default {
  name: 'DashboardBecasExternas',
  components: { BecariosExternos, ReportesSolicitudesDialog },
  computed: { ...authComputed,

     carrerasDisponibles() {
    const base = this.becasAll || []
    const set = new Set()

    base.forEach(b => {
      const carrera = (b?.carrera || '').toString().trim()
      if (carrera) set.add(carrera)
    })

    return Array.from(set).sort((a, b) => a.localeCompare(b))
  }

   },

  data: () => ({
    // UI
    loading: false,
    snackbar: false,
    snackText: '',
    snackColor: 'primary',
    generandoReporte: false,

    // Filtros
    cmbCiclos: [],
    selectCiclo: '',

    cmbInstituciones: [],
    selectInstitucion: null, // null = Todas

    // Datos
    becasAll: [], // datos del ciclo (sin filtrar)
    becas: [],    // datos filtrados por institución (si aplica)

    // KPIs
    kpi: {
      total: 0,
      instituciones: 0,
      carreras: 0,
    },

    // Charts (top 8)
    chartInstituciones: [],
    chartCarreras: []
  }),

  watch: {
    selectCiclo() {
      this.cargarDashboard()
    },
    selectInstitucion() {
      this.recalcularDashboard()
    }
  },

  created() {
    // Validando acceso (misma idea que tu componente actual)
    if (this.permController && this.permController(11, 'ver')) {
      this.cargarCiclos()
      this.cargarInstituciones()
    } else {
      this.$router.push({ name: 'inicio' })
    }
  },

  methods: {
   setColumnWidths(ws) {
  ws['!cols'] = [
    { wch: 16 }, // Carnet
    { wch: 35 }, // Nombre
    { wch: 15 }, // Periodo Lectivo
    { wch: 30 }, // Institucion
    { wch: 16 }, // Fecha ADJUNTO
    { wch: 45 }  // Carrera
  ]
},
async refrescarDashboard() {
  if (!this.selectCiclo) return

  // opcional: limpia filtros de institución al refrescar
  // this.selectInstitucion = null

  this.loading = true
  try {
    const { data } = await axios.get('api/BecarioExterno?Ciclo=' + this.selectCiclo)
    this.becasAll = data || []
    this.recalcularDashboard()

    this.snackText = 'Dashboard actualizado'
    this.snackColor = 'snackSuccess'
    this.snackbar = true
  } catch (e) {
    console.log(e)
    this.snackText = 'No se pudo refrescar el dashboard'
    this.snackColor = 'snackError'
    this.snackbar = true
  } finally {
    this.loading = false
  }
},


  async onReporteCompleto(payload) {
  if (!this.selectCiclo) return

  try {
    this.generandoReporte = true
    let rows = (this.becasAll || []).slice()

    // Si quieres SIEMPRE completo sin filtro, comenta este bloque.
    if (payload?.filtro === 'career' && payload?.carrera) {
      rows = rows.filter(r => (r.carrera || '') === payload.carrera)
    }
    if (payload?.filtro === 'institution' && payload?.institucionId) {
      const hasId =
        rows.length > 0 &&
        Object.prototype.hasOwnProperty.call(rows[0], 'institucionPatrocinadoraId')

      if (hasId) {
        rows = rows.filter(r => r.institucionPatrocinadoraId === payload.institucionId)
      } else {
        const instName =
          this.cmbInstituciones.find(x => x.institucionPatrocinadoraId === payload.institucionId)?.nombre || ''
        rows = rows.filter(r => (r.institucionPatrocinadora || '') === instName)
      }
    }

    const headers = ['Carnet', 'Nombre', 'Periodo Lectivo', 'Institucion', 'Fecha ADJUNTO', 'Carrera']

    const rowToExcel = (r) => ([
      (r.carnet ?? '').toString(),
      (r.nombre ?? '').toString(),
      (r.ciclo ?? r.periodoLectivo ?? this.selectCiclo ?? '').toString(),
      (r.institucionPatrocinadora ?? '').toString(),
      (r.fecha ?? r.fechaAdjunto ?? '').toString(),
      (r.carrera ?? '').toString()
    ])

    const safeKey = (v) => ((v ?? '').toString().trim() || 'Sin dato')
    const groupBy = (arr, keyFn) => {
      const m = new Map()
      for (const it of arr) {
        const k = safeKey(keyFn(it))
        if (!m.has(k)) m.set(k, [])
        m.get(k).push(it)
      }
      return m
    }

    const wb = XLSX.utils.book_new()

    // 1) Datos_Completos
    const wsDatos = XLSX.utils.aoa_to_sheet([headers], { origin: 'A1' })
    const datosAoa = rows.map(rowToExcel)
    if (datosAoa.length) XLSX.utils.sheet_add_aoa(wsDatos, datosAoa, { origin: 'A2' })

    this.setColumnWidths(wsDatos)
    XLSX.utils.book_append_sheet(wb, wsDatos, 'Datos_Completos')

    // 2) resumen_carrera
    const byCarrera = groupBy(rows, r => r.carrera)
    const resumenCarreraAoa = [
      ['Carrera', 'Total alumnos'],
      ...Array.from(byCarrera.entries())
        .map(([carrera, items]) => [carrera, items.length])
        .sort((a, b) => Number(b[1]) - Number(a[1]))
    ]
    const wsResumenCarrera = XLSX.utils.aoa_to_sheet(resumenCarreraAoa, { origin: 'A1' })
    this.setColumnWidths(wsResumenCarrera)
    XLSX.utils.book_append_sheet(wb, wsResumenCarrera, 'resumen_carrera')

    // 3) Carreras (bloques)
    const wsCarreras = XLSX.utils.aoa_to_sheet([], { origin: 'A1' })
    let rowCursor = 1

    const writeBlock = (ws, title, items) => {
      XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: `A${rowCursor}` })
      XLSX.utils.sheet_add_aoa(ws, [headers], { origin: `A${rowCursor + 1}` })

      const dataAoa = items.map(rowToExcel)
      if (dataAoa.length) XLSX.utils.sheet_add_aoa(ws, dataAoa, { origin: `A${rowCursor + 2}` })

      rowCursor = rowCursor + 2 + Math.max(dataAoa.length, 1) + 2
    }

    const carrerasOrdenadas = Array.from(byCarrera.entries()).sort((a, b) => a[0].localeCompare(b[0]))
    for (const [carrera, items] of carrerasOrdenadas) {
      writeBlock(wsCarreras, `Carrera de ${carrera}`, items)
    }

    this.setColumnWidths(wsCarreras)
    XLSX.utils.book_append_sheet(wb, wsCarreras, 'Carreras')

    // 4) Instituciones (bloques)
    const byInst = groupBy(rows, r => r.institucionPatrocinadora)
    const wsInst = XLSX.utils.aoa_to_sheet([], { origin: 'A1' })
    rowCursor = 1

    const instOrdenadas = Array.from(byInst.entries()).sort((a, b) => a[0].localeCompare(b[0]))
    for (const [inst, items] of instOrdenadas) {
      writeBlock(wsInst, `Institución: ${inst}`, items)
    }

    this.setColumnWidths(wsInst)
    XLSX.utils.book_append_sheet(wb, wsInst, 'Instituciones')

    const today = new Date()
    const filename =
      `Reporte_Completo_Becas_Externas_${this.selectCiclo}_${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}.xlsx`

    XLSX.writeFile(wb, filename)

    this.snackText = 'Reporte completo generado'
    this.snackColor = 'snackSuccess'
    this.snackbar = true
  } catch (e) {
    console.log(e)
    this.snackText = 'No se pudo generar el reporte completo'
    this.snackColor = 'snackError'
    this.snackbar = true
  } finally {
    this.generandoReporte = false
  }
},



   
groupAll(items, key, sortBy = 'label') {
  const map = new Map()
  for (const it of items) {
    const k = (it?.[key] || 'Sin dato').toString().trim() || 'Sin dato'
    map.set(k, (map.get(k) || 0) + 1)
  }

  let rows = Array.from(map.entries()).map(([label, value]) => ({ label, value }))

  if (sortBy === 'value') {
    rows.sort((a, b) => b.value - a.value)
  } else {
    rows.sort((a, b) => a.label.localeCompare(b.label))
  }

  const max = rows[0]?.value || 0
  return rows.map(r => ({
    ...r,
    pct: max ? Math.round((r.value / max) * 100) : 0
  }))
},


    async cargarCiclos() {
      try {
        const { data } = await axios.get('api/Ciclos')
        this.cmbCiclos = data || []
        this.selectCiclo = this.cmbCiclos?.[0]?.nombre || ''
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando ciclos'
        this.snackColor = 'snackError'
        this.snackbar = true
      }
    },

    async cargarInstituciones() {
      try {
        const { data } = await axios.get('api/InstitucionPatrocinadora')
        this.cmbInstituciones = data || []
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando instituciones'
        this.snackColor = 'snackError'
        this.snackbar = true
      }
    },

    async cargarDashboard() {
      if (!this.selectCiclo) return

      this.loading = true
      try {
        const { data } = await axios.get(
          'api/BecarioExterno?Ciclo=' + this.selectCiclo
        )
        this.becasAll = data || []
        this.recalcularDashboard()
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando becarios externos'
        this.snackColor = 'snackError'
        this.snackbar = true
      } finally {
        this.loading = false
      }
    },

    recalcularDashboard() {
      if (!this.selectCiclo) {
        this.becasAll = []
        this.becas = []
        this.kpi.total = 0
        this.kpi.instituciones = 0
        this.kpi.carreras = 0
        this.chartInstituciones = []
        this.chartCarreras = []
        return
      }

      const base = this.becasAll || []

      // Preferimos filtrar por ID si existe en el item.
      // Si no existe institucionPatrocinadoraId en los items, cae a filtrar por nombre.
      const hasId = base.length > 0 && Object.prototype.hasOwnProperty.call(base[0], 'institucionPatrocinadoraId')

      if (this.selectInstitucion) {
        if (hasId) {
          this.becas = base.filter(
            (i) => i.institucionPatrocinadoraId === this.selectInstitucion
          )
        } else {
          const instName =
            this.cmbInstituciones.find(
              (x) => x.institucionPatrocinadoraId === this.selectInstitucion
            )?.nombre || ''

          this.becas = base.filter(
            (i) => (i.institucionPatrocinadora || '') === instName
          )
        }
      } else {
        // null => Todas
        this.becas = base
      }

      this.calcularKPIs()
      this.calcularCharts()
    },

    calcularKPIs() {
      const items = this.becas || []
      const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)))

      this.kpi.total = items.length
      this.kpi.instituciones = uniq(
        items.map((i) => i.institucionPatrocinadora)
      ).length
      this.kpi.carreras = uniq(items.map((i) => i.carrera)).length
    },

    topNGroup(items, key, n = 8) {
      const map = new Map()
      for (const it of items) {
        const k = (it?.[key] || 'Sin dato').toString().trim() || 'Sin dato'
        map.set(k, (map.get(k) || 0) + 1)
      }
      const rows = Array.from(map.entries())
        .map(([label, value]) => ({ label, value }))
        .sort((a, b) => b.value - a.value)
        .slice(0, n)

      const max = rows[0]?.value || 0
      return rows.map((r) => ({
        ...r,
        pct: max ? Math.round((r.value / max) * 100) : 0
      }))
    },

    calcularCharts() {
      // Si hay institución seleccionada, "Top instituciones" deja de ser útil (sería 1 sola),
      // así que mostramos el top con base en lo filtrado (lo cual será 1) o puedes cambiarlo
      // para que siempre muestre el top del ciclo usando this.becasAll.
      this.chartInstituciones = this.topNGroup(
        this.becas,
        'institucionPatrocinadora',
        8
      )
      // Carreras: mostrar TODAS las que tienen becados (sin top)
  // Puedes ordenar por 'label' (alfabético) o por 'value' (cantidad desc).
  this.chartCarreras = this.groupAll(this.becas, 'carrera', 'value')
    },

  
  }
}
</script>

